module.exports = __webpack_public_path__ + "img/TorrFin.909410f2.png";